import React from 'react'
import { Layout, Typography, Space, Button, Tag, Tooltip, Spin, Tabs } from 'antd'
import {
  DatabaseOutlined,
  LogoutOutlined,
  RobotOutlined,
  CheckCircleOutlined,
  LoadingOutlined,
  TableOutlined
} from '@ant-design/icons'
import { useNavigate, useLocation } from 'react-router-dom'
import { SystemInfo } from '../types/api'

const { Header: AntHeader } = Layout
const { Title } = Typography

interface HeaderProps {
  systemInfo: SystemInfo | null
  isAuthenticated: boolean
  onLogout: () => void
}

const Header: React.FC<HeaderProps> = ({ systemInfo, isAuthenticated, onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // 导航标签配置
  const navigationTabs = [
    {
      key: '/query',
      label: (
        <Space>
          <RobotOutlined />
          AI智能查询
        </Space>
      )
    },
    {
      key: '/browse',
      label: (
        <Space>
          <TableOutlined />
          数据浏览
        </Space>
      )
    }
  ];

  return (
    <AntHeader className="app-header">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <DatabaseOutlined style={{ fontSize: 24, color: '#1890ff', marginRight: 12 }} />
          <Title level={3} style={{ margin: 0, color: '#1890ff' }}>
            成本分析系统
          </Title>

          {systemInfo ? (
            systemInfo.available_tables && systemInfo.factories && systemInfo.ai_model ? (
              <Space style={{ marginLeft: 24 }}>
                <Tooltip title={`数据库包含 ${systemInfo.available_tables?.length || 0} 个表`}>
                  <Tag icon={<DatabaseOutlined />} color="blue">
                    {systemInfo.available_tables?.length || 0} 表
                  </Tag>
                </Tooltip>

                <Tooltip
                  title={`AI模型: ${systemInfo.ai_model?.name || 'Unknown'} ${systemInfo.ai_model?.simulated ? '(模拟模式)' : ''}`}
                >
                  <Tag
                    icon={<RobotOutlined />}
                    color={systemInfo.ai_model?.available ? 'green' : 'orange'}
                  >
                    {systemInfo.ai_model?.name || 'Unknown'}
                    {systemInfo.ai_model?.simulated && ' (模拟)'}
                  </Tag>
                </Tooltip>

                <Tooltip title="工厂数量">
                  <Tag color="purple">
                    {systemInfo.factories?.length || 0} 工厂
                  </Tag>
                </Tooltip>
              </Space>
            ) : (
              <Space style={{ marginLeft: 24 }}>
                <Tag color="default">
                  系统信息加载中...
                </Tag>
              </Space>
            )
          ) : (
            <Space style={{ marginLeft: 24 }}>
              <Spin
                indicator={<LoadingOutlined style={{ fontSize: 16 }} spin />}
                size="small"
              />
              <Tag color="default">
                正在连接系统...
              </Tag>
            </Space>
          )}
        </div>

        {/* 导航标签 */}
        {isAuthenticated && (
          <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
            <Tabs
              activeKey={location.pathname}
              items={navigationTabs}
              onChange={(key) => navigate(key)}
              size="large"
              style={{
                marginBottom: 0
              }}
            />
          </div>
        )}

        <Space>
          {systemInfo && (
            <Tooltip title="系统状态">
              <Tag
                icon={<CheckCircleOutlined />}
                color="success"
              >
                系统正常
              </Tag>
            </Tooltip>
          )}

          {isAuthenticated && (
            <Button
              type="text"
              icon={<LogoutOutlined />}
              onClick={onLogout}
            >
              退出登录
            </Button>
          )}
        </Space>
      </div>
    </AntHeader>
  )
}

export default Header
